exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-wrap[data-v-5d7177a9] {\n  text-align: center;\n}", ""]);

// exports
